@if (mailLoading) {
<div class="text-center loader">
	<img src="../../../assets/img/loading.gif" />
</div>
}
<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (navbar.userAccess?.Appointments=='Full' || navbar.userAccess?.Appointments=='Readonly') {
<div class="row g-1">
	@if (mailList.length) {
	<div class="col-3">
		@for (mail of mailList; track $index) {
		<app-mail-display [mail]="mail" [showTrail]="false"></app-mail-display>
		}
	</div>
	}
	<div [ngClass]="mailList.length?'col-9':'col-12'">
		<div class="card">
			<div class="card-header bg-theme mb-0">
				<h5 class="card-title text-light mb-0">
					{{pagetitle}}
					@if (mailList.length && selectedCaseIds.length) {
					<button class="btn btn-xs btn-light float-end ms-1" matTooltip="Link" (click)="linkMails()">
						@if (showLinkLoader) {
						<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						}@else {
						<fa-icon [icon]="['fas', 'link']"></fa-icon>
						}
						Link
						{{selectedCaseIds.length}}
						case(s)
					</button>
					}
					@if(navbar.userAccess?.Appointments=='Full'){
					<a class="btn btn-xs btn-light float-end ms-1" [routerLink]="['/app/book-appointment']"
						[queryParams]="mailsParam?{ mails: mailsParam }:undefined">
						<fa-icon [icon]="['fas', 'plus']"></fa-icon>
						Create Appointment
					</a>
					}
					<button class="btn btn-xs btn-warning float-end ms-1" matTooltip="Excel"
						[disabled]="caseExcelLoader" (click)="getExcel()">
						@if (caseExcelLoader) {
						<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						}@else {
						<fa-icon [icon]="['fas', 'cloud-download-alt']"></fa-icon>
						}
					</button>
				</h5>
			</div>
			<div class="card-body pt-0">
				<mat-accordion [hideToggle]="false">
					<mat-expansion-panel [expanded]="false">
						<mat-expansion-panel-header class="bg-secondary" [collapsedHeight]="'35px'"
							[expandedHeight]="'40px'">
							<mat-panel-title>
								<strong class="text-white">
									<fa-icon [icon]="['fas','filter']"></fa-icon>
									Advanced Search
								</strong>
							</mat-panel-title>
							<mat-panel-description>
							</mat-panel-description>
						</mat-expansion-panel-header>
						<div class="row g-1 mt-1">
							<div class="col-md-4">
								<ng-select [items]="hospitalList" bindLabel="name" bindValue="id" [clearable]="true"
									[(ngModel)]="filters.hospital" placeholder="Hospital" [appearance]="'outline'"
									(change)="getDoctorList();refreshTable();" appendTo="body">
								</ng-select>
							</div>
							<div class="col-md-4">
								<ng-select [items]="doctorList" bindLabel="name" bindValue="id" [clearable]="true"
									[(ngModel)]="filters.doctor" placeholder="Doctor" [appearance]="'outline'"
									(change)="refreshTable();" appendTo="body">
								</ng-select>
							</div>
							<div class="col-md-2">
								<ng-select [items]="caseStatusList" bindLabel="name" bindValue="id" [clearable]="true"
									[(ngModel)]="filters.case_status" placeholder="Case Status" [appearance]="'outline'"
									(change)="refreshTable();" appendTo="body">
								</ng-select>
							</div>
							<div class="col-md-2">
								<ng-select [items]="allCaseCategories" bindValue="id" bindLabel="name"
									[clearable]="true" placeholder="Case Category" [(ngModel)]="filters.case_category"
									appearance="outline" (change)="refreshTable();" appendTo="body">
								</ng-select>
							</div>
						</div>
						<div class="row g-1 mt-1">
							<div class="col-md-4">
								<ng-select [items]="companyList" bindLabel="com_name" bindValue="id" [clearable]="true"
									[(ngModel)]="filters.company" placeholder="Company" [appearance]="'outline'"
									(change)="refreshTable();" appendTo="body">
								</ng-select>
							</div>
							<div class="col-md-4">
								<div class="w-50 float-start pe-1">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control" placeholder="" [(ngModel)]="filters.from_date"
												ngbDatepicker id="from_date" #from_date="ngbDatepicker"
												[minDate]="minDate" [container]="'body'"
												(ngModelChange)="refreshTable()" />
											<label for="from_date">From</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="from_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
								</div>
								<div class="w-50 float-start ps-1">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control" placeholder="" [(ngModel)]="filters.to_date"
												ngbDatepicker id="to_date" #to_date="ngbDatepicker" [minDate]="minDate"
												[container]="'body'" (ngModelChange)="refreshTable()" />
											<label for="to_date">To</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="to_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
								</div>
							</div>
							<div class="col-md-4">
								<mat-checkbox [color]="'primary'" [(ngModel)]="filters.physiotherapy"
									(change)="physiotherapyChanged();refreshTable();" class="me-2">
									Ongoing Physiotherapy
								</mat-checkbox>
								<mat-checkbox [color]="'primary'" [(ngModel)]="filters.upcoming_arrival"
									(change)="refreshTable()">
									Upcoming Arrivals
								</mat-checkbox>
								<mat-checkbox [color]="'primary'" [(ngModel)]="filters.not_replied"
									(change)="refreshTable()">
									Not Replied
								</mat-checkbox>
							</div>
						</div>
					</mat-expansion-panel>
				</mat-accordion>
				<div class="table-responsive">
					@if(dtOptions.pagingType){
					<table datatable [dtOptions]="dtOptions"
						class="table table-striped table-bordered table-hover appt-table"
						style="width: 100%;border: 1px solid rgb(187, 187, 187);">
						<thead>
							<tr class="table_head">
								<th style="width: 10%;">Case ID</th>
								<th style="width: 10%;">Start Date</th>
								<th style="width: 10%;">Next Follow-up</th>
								<th style="width: 15%;">Company</th>
								<th style="width: 12%;">Vessel</th>
								<th style="width: 13%;">Crew Name</th>
								<th style="width: 12%;">Contact</th>
								<th style="width: 8%;">Category</th>
								<th style="width: 5%;">Status</th>
								<th style="width: 5%;" class="text-center">Action</th>
							</tr>
						</thead>
						@if (dataList?.length) {
						<tbody>
							<tr *ngFor="let v of dataList;let i = index;">
								<td>
									<a [routerLink]="['/app/appt-details','no',v.enc_id,'empty']">
										<span matTooltip="Details">
											{{v.case_id}}
										</span>
										@if(!v.isReplied){
										<fa-icon [icon]="['fas','envelope']" matTooltip="Not replied"></fa-icon>
										}
									</a>
								</td>
								<td>{{ v.start_date }}</td>
								<td>{{ v.next_followup_date }}</td>
								<td>{{ v.company?.com_name }}</td>
								<td>{{ v.vessel?.vessel_name }}</td>
								<td>{{ v.candidate.f_name }} {{ v.candidate.l_name }}</td>
								<td>{{ v.candidate.country_code }} {{ v.candidate.tel_no }}</td>
								<td>{{ v.case_category?.name }}</td>
								<td>
									<fa-icon [icon]="['fas',v.status_id==2?'lock':'lock-open']"
										matTooltip="{{ v.status_name }}" class="ms-1 me-2">
									</fa-icon>
									@if (v.closure_report_sent) {
									<fa-icon [icon]="['fas', 'check-square']" class="text-success"
										[ngbPopover]="tooltip_report_sent" [popoverClass]="'closure-popover'"
										[popoverTitle]="'Closure report sent'" [matTooltip]="'Closure report sent'"
										container="body" role="button">
									</fa-icon>
									<ng-template #tooltip_report_sent>
										<p class="small mb-0">
											Updated by
											<strong>
												{{v.closure_report_sent_by}}
											</strong>
										</p>
										<p class="small mb-0">
											Date
											<strong>
												{{v.closure_report_sent_date}}
											</strong>
										</p>
									</ng-template>
									}
								</td>
								<td class="text-center">
									@if(navbar.userAccess?.Appointments=='Full'){
									<button class="btn btn-xs btn-danger ms-1" matTooltip="Delete"
										(click)="deleteConfirm(v)">
										@if (showDeleteLoader == v.id) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'trash']"></fa-icon>
										}
									</button>
									<button class="btn btn-xs btn-success ms-1" matTooltip="Case summary"
										(click)="getCaseSummary(v)" [disabled]="summaryLoader">
										@if(summaryLoader == v.id){
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"
											class="color-gold"></fa-icon>
										}@else{
										<img src="../../../assets/img/sparkling.png" alt="Icon" class="sparkling-img">
										<!-- <fa-icon [icon]="['fas', 'list-alt']"></fa-icon> -->
										}
									</button>
									@if (mailList.length) {
									<!-- <button class="btn btn-xs btn-primary ms-1" matTooltip="Link"
										(click)="linkMails(v)">
										@if (showLinkLoader == v.id) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'link']"></fa-icon>
										}
									</button> -->
									<mat-checkbox [color]="'primary'" [(ngModel)]="v.selected" matTooltip="Select"
										(change)="checked_unchecked(v)">
									</mat-checkbox>
									}
									}
								</td>
							</tr>
						</tbody>
						}@else {
						<tbody>
							<tr>
								<td colspan="10" class="text-center">No data found!</td>
							</tr>
						</tbody>
						}
					</table>
					}
				</div>
			</div>
		</div>
	</div>
</div>
}@else if(navbar.userAccess?.Appointments=='NoAccess') {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}
<div class="modal fade" id="caseSummaryModalListPage" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>{{currentCaseObj?.case_id}}</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12" [innerHTML]="currentCaseObj?.summaryStr | safeHtml">
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">
					OK
				</button>
			</div>
		</div>
	</div>
</div>